export function dataInRequest(params = {}) {
  return {
    type: '@checkxmlnfrecebimentonf/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@checkxmlnfrecebimentonf/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@checkxmlnfrecebimentonf/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@checkxmlnfrecebimentonf/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@checkxmlnfrecebimentonf/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@checkxmlnfrecebimentonf/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@checkxmlnfrecebimentonf/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@checkxmlnfrecebimentonf/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@checkxmlnfrecebimentonf/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@checkxmlnfrecebimentonf/RECORD_FILTERING',
    payload: { params },
  };
}
